"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preventDropdownFromClosing = exports.ZIndexWrapper = exports.StyledDropdownLi = exports.OptionGroupName = exports.DropdownTriggerStyledButton = exports.DropdownMetaItemStyle = exports.DropdownListLabel = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _context = require("../../context");

var _layout = require("../../layout");

var _styles = require("../../styles");

var _utils = require("../../utils");

var _constants = require("./constants");

var _interfaces = require("./interfaces");

var _core = require("@emotion/core");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var DropdownListLabelStyle = (0, _context.styledWithTheme)('li')(function (_ref) {
  var selectors = _ref.theme.selectors;
  return {
    backgroundColor: selectors.color('neutral0'),
    borderBottom: "".concat((0, _utils.px)(_constants.DIVIDER_WIDTH), " solid ").concat(selectors.color(_constants.BORDER_COLOR)),
    color: selectors.color(_constants.LABEL_TEXT_COLOR),
    fontFamily: selectors.fontFamily('primary'),
    padding: (0, _utils.px)(selectors.space(_constants.ITEM_PADDING))
  };
});

var DropdownListLabel = function DropdownListLabel(props) {
  return (0, _core.jsx)(DropdownListLabelStyle, (0, _extends2.default)({
    role: "presentation",
    onMouseUpCapture: preventDropdownFromClosing
  }, props));
};

exports.DropdownListLabel = DropdownListLabel;
var OptionGroupNameStyle = (0, _context.styledWithTheme)('li')(function (_ref2) {
  var selectors = _ref2.theme.selectors;
  return {
    backgroundColor: selectors.color('neutral0'),
    color: selectors.color(_constants.LABEL_TEXT_COLOR),
    fontFamily: selectors.fontFamily('primary'),
    fontWeight: selectors.fontWeight('bold'),
    padding: (0, _utils.px)(selectors.space(_constants.ITEM_PADDING)),
    lineHeight: 1.5
  };
});

var OptionGroupName = function OptionGroupName(props) {
  return (0, _core.jsx)(OptionGroupNameStyle, (0, _extends2.default)({
    onMouseUpCapture: preventDropdownFromClosing
  }, props));
};

exports.OptionGroupName = OptionGroupName;
var ZIndexWrapper = (0, _context.styledWithTheme)('div')(function (_ref3) {
  var theme = _ref3.theme,
      isOpen = _ref3.isOpen,
      isAlwaysOpened = _ref3.isAlwaysOpened;
  return _objectSpread({
    zIndex: isOpen ? theme.selectors.zIndex('dropdown') : 0
  }, isAlwaysOpened && {
    width: '100%',
    padding: (0, _utils.px)(theme.selectors.space('S200'))
  });
});
exports.ZIndexWrapper = ZIndexWrapper;
var StyledDropdownLi = (0, _context.styledWithTheme)('li')(function (_ref4) {
  var _ref4$theme = _ref4.theme,
      selectors = _ref4$theme.selectors,
      isInHighContrast = _ref4$theme.isInHighContrast,
      isHighlighted = _ref4.isHighlighted,
      isSelected = _ref4.isSelected,
      isSelectedNavigation = _ref4.isSelectedNavigation,
      withCustomSelectionOptions = _ref4.withCustomSelectionOptions;
  var backgroundColor;

  if (isSelectedNavigation) {
    backgroundColor = isHighlighted ? _constants.NAVIGATION_HIGHLIGHT_COLOR : _constants.NAVIGATION_SELECTED_COLOR;
  } else if (isSelected) {
    backgroundColor = isHighlighted && isSelected ? _constants.HIGHLIGHT_SELECTED_COLOR : _constants.HIGHLIGHT_COLOR;
  } else {
    backgroundColor = isHighlighted ? _constants.HIGHLIGHT_COLOR : 'neutral0';
  }

  var padding = selectors.space(_constants.ITEM_PADDING) || 8;
  var selectedStyle = {
    paddingLeft: padding * 2,
    ':before': {
      display: 'block',
      content: '""',
      width: 5,
      height: '100%',
      backgroundColor: isInHighContrast ? 'CanvasText' : selectors.color(_constants.NAVIGATION_SELECTED_COLOR),
      position: 'absolute',
      alignSelf: 'stretch',
      borderRadius: "".concat((0, _utils.px)(padding), " 0 0 ").concat((0, _utils.px)(padding)),
      top: 0,
      left: 0
    }
  };
  return _objectSpread(_objectSpread(_objectSpread({
    borderRadius: selectors.radius(_constants.ITEM_BORDER_RADIUS),
    padding: padding,
    marginTop: padding / 2,
    marginBottom: padding / 2,
    '&:first-of-type': {
      marginTop: 0
    },
    '&:last-of-type': {
      marginBottom: 0
    },
    fontFamily: selectors.fontFamily('primary'),
    fontSize: selectors.fontSize(_constants.FONT_SIZE),
    lineHeight: selectors.lineHeight(_constants.FONT_SIZE),
    color: selectors.color(_constants.TEXT_COLOR),
    backgroundColor: selectors.color(backgroundColor),
    cursor: 'pointer',
    position: 'relative'
  }, withCustomSelectionOptions && {
    paddingLeft: (0, _utils.px)(selectors.space(_constants.ITEM_WITH_GROUPING_LEFT_PADDING))
  }), isSelected && selectedStyle), isHighlighted && isInHighContrast && {
    outlineStyle: 'solid',
    outlineOffset: '-2px'
  });
});
exports.StyledDropdownLi = StyledDropdownLi;
var DropdownMetaItemStyle = (0, _context.styledWithTheme)(_layout.View)(function (_ref5) {
  var selectors = _ref5.theme.selectors,
      shouldHaveNoBorder = _ref5.shouldHaveNoBorder,
      borderPosition = _ref5.borderPosition;
  return _objectSpread({
    fontFamily: selectors.fontFamily('primary'),
    fontSize: selectors.fontSize(_constants.FONT_SIZE),
    lineHeight: selectors.lineHeight(_constants.FONT_SIZE),
    color: selectors.color(_constants.TEXT_COLOR),
    backgroundColor: selectors.color('neutral0'),
    padding: (0, _utils.px)(selectors.space(_constants.ITEM_PADDING))
  }, !shouldHaveNoBorder && (0, _defineProperty2.default)({}, borderPosition === _interfaces.DropdownItemBorderPosition.Bottom ? 'borderBottom' : 'borderTop', "".concat(_constants.DIVIDER_WIDTH, "px solid ").concat(selectors.color(_constants.BORDER_COLOR))));
});
exports.DropdownMetaItemStyle = DropdownMetaItemStyle;
var DropdownTriggerStyledButton = (0, _context.styledWithTheme)('button')(function (_ref7) {
  var selectors = _ref7.theme.selectors,
      hasAriaDisabled = _ref7.hasAriaDisabled,
      disabled = _ref7.disabled,
      error = _ref7.error,
      warning = _ref7.warning,
      borderRadius = _ref7.borderRadius;
  var isDisabled = disabled || hasAriaDisabled;
  return _objectSpread(_objectSpread(_objectSpread({
    display: 'block',
    appearance: 'none',
    WebkitAppearance: 'none',
    width: '100%'
  }, (0, _styles.inputStyles)({
    error: error,
    warning: warning,
    selectors: selectors,
    props: {},
    borderRadius: borderRadius
  })), (0, _styles.disabledStyles)({
    error: error,
    disabled: isDisabled,
    selectors: selectors,
    warning: warning
  })), {}, {
    cursor: isDisabled ? 'not-allowed' : 'pointer'
  });
});
exports.DropdownTriggerStyledButton = DropdownTriggerStyledButton;

var preventDropdownFromClosing = function preventDropdownFromClosing(event) {
  event.stopPropagation();
};

exports.preventDropdownFromClosing = preventDropdownFromClosing;